export const LANG_STORAGE_KEY = 'rss-orders-lang';

export function detectLanguage(storage = localStorage, nav = navigator) {
  const stored = storage.getItem(LANG_STORAGE_KEY);
  if (stored) return stored;
  return nav.language?.startsWith('es') ? 'es' : 'en';
}
